export default __webpack_public_path__ + "static/media/archive_image@2x.be60e6d7.png";